<template>
	<div>
		<div class="d-md-flex align-items-center">
			<DatePicker
				v-model="dateRange"
				@input="emitDates"
				class="w-100"
				format="MM-DD-YYYY"
				input-class="form-control form-control-sm rounded-sm"
				prefix-class="xmx"
				range-separator=" to "
				range
			/>

			<span class="w-25 px-2 text-center">OR</span>

			<b-form-group v-slot="{ ariaDescribedby }" class="w-100">
				<b-form-radio-group
					v-model="modelValue"
					:options="dateOptions"
					:aria-describedby="ariaDescribedby"
					stacked
				></b-form-radio-group>
			</b-form-group>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	props: ['value'],
	components: { DatePicker },
	data() {
		return {
			dateRange: [],
			datePicker: null,
			dateOptions: [
				{ value: null, text: 'All' },
				{ value: 'prev-month', text: 'Last Month' },
				{ value: 'prev-week', text: 'Last Week' },
				{ value: 'current-month', text: 'This Month' },
			],
		};
	},
	computed: {
		modelValue: {
			get() {
				if (!this.value) return null;

				if ('string' === typeof this.value) {
					return this.value;
				} else {
					const startMonth = moment().startOf('month');
					const endMonth = moment().endOf('month');

					if (
						this.value.from === startMonth.format('MM-DD-YYYY') &&
						this.value.to === endMonth.format('MM-DD-YYYY')
					)
						return 'current-month';
					else if (
						this.value.from ===
							startMonth.subtract(1, 'month').format('MM-DD-YYYY') &&
						this.value.to ===
							endMonth.subtract(1, 'month').format('MM-DD-YYYY')
					)
						return 'prev-month';
					else if (
						this.value.from ===
							moment()
								.startOf('week')
								.subtract(1, 'week')
								.format('MM-DD-YYYY') &&
						this.value.to ===
							moment()
								.endOf('week')
								.subtract(1, 'week')
								.format('MM-DD-YYYY')
					)
						return 'prev-week';
					else return this.value;
				}
			},
			set(newValue) {
				this.dateRange = null;

				if (!newValue) {
					this.emitDates(null);
				} else if ('string' == typeof newValue) {
					if ('prev-week' === newValue) {
						this.emitDates([
							moment().startOf('week').subtract(1, 'week').toDate(),
							moment().endOf('week').subtract(1, 'week').toDate(),
						]);
					} else {
						const startMonth = moment().startOf('month');
						const endMonth = moment().endOf('month');

						if ('prev-month' === newValue) {
							startMonth.subtract(1, 'month');
							endMonth.subtract(1, 'month');
						}

						this.emitDates([startMonth.toDate(), endMonth.toDate()]);
					}
				} else {
					this.dateRange = [
						moment(newValue.from, 'MM-DD-YYYY').toDate(),
						moment(newValue.to, 'MM-DD-YYYY').toDate(),
					];
				}
			},
		},
	},
	methods: {
		emitDates(value) {
			if (value && value.filter((item) => item).length)
				this.$emit('input', {
					from: moment(value[0]).format('MM-DD-YYYY'),
					to: moment(value[1]).format('MM-DD-YYYY'),
				});
			else this.$emit('input', null);
		},
	},
	mounted() {
		if (this.modelValue && this.modelValue.from && this.modelValue.to)
			this.dateRange = [
				moment(this.modelValue.from, 'MM-DD-YYYY').toDate(),
				moment(this.modelValue.to, 'MM-DD-YYYY').toDate(),
			];
	},
};
</script>
